var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "nav-tabs-custom"]
var hoisted2 = ["class", "nav nav-tabs"]
var hoisted3 = ["class", "active"]
var hoisted4 = ["data-toggle", "tab"]
var hoisted5 = ["class", "graph", "data-toggle", "tab"]
var hoisted6 = ["data-toggle", "tab"]
var hoisted7 = ["class", "tab-content"]
var hoisted8 = ["class", "tab-pane active"]
var hoisted9 = ["icon", "database"]
var hoisted10 = ["class", "alert alert-danger"]
var hoisted11 = ["class", "text-danger"]
var hoisted12 = ["class", "text-danger"]
var hoisted13 = ["class", "row"]
var hoisted14 = ["class", "col-xs-6"]
var hoisted15 = ["class", "tree"]
var hoisted16 = ["class", "fa fa-database"]
var hoisted17 = ["class", "fa fa-table"]
var hoisted18 = ["class", "col-xs-6"]
var hoisted19 = ["class", "tab-pane"]
var hoisted20 = ["type", "button", "class", "btn btn-box-tool expand"]
var hoisted21 = ["class", "fa fa-expand"]
var hoisted22 = ["type", "button", "class", "btn btn-box-tool collapse"]
var hoisted23 = ["class", "fa fa-compress"]
var hoisted24 = ["class", "model-graph", "id", "model-graph"]
var hoisted25 = ["class", "tab-pane"]
var hoisted26 = ["style", "height: 400px"]
var __target

module.exports = function description (ctrl, modelView, schemaView, keysView, keyView) {
  var model = ctrl.model
      var breadcrumbs = ctrl.breadcrumbs
  elementOpen("div", "ce528af4-6d21-4601-b393-7ea7bcaa9332", hoisted1)
    elementOpen("ul", "f7cbfae1-2a2f-478c-8679-9c3681e288e6", hoisted2)
      elementOpen("li", "077bcb89-d4ab-43d6-a2eb-97e1d67730a5", hoisted3)
        elementOpen("a", "85cbe574-1b0f-41f1-b992-60cc2f8c548f", hoisted4, "href", "#_" + (ctrl.id) + "_1")
          text("Editor")
        elementClose("a")
      elementClose("li")
      elementOpen("li")
        elementOpen("a", "4a51e41c-a1fb-47ff-964c-c935d58e4acf", hoisted5, "href", "#_" + (ctrl.id) + "_2")
          text("Diagram")
        elementClose("a")
      elementClose("li")
      elementOpen("li")
        elementOpen("a", "91b9d05a-8d84-4007-aecb-402b905d1077", hoisted6, "href", "#_" + (ctrl.id) + "_3")
          text("JSON")
        elementClose("a")
      elementClose("li")
    elementClose("ul")
    elementOpen("div", "0bf607c0-8d0a-4b38-b637-ab83c58f9d05", hoisted7)
      elementOpen("div", "b676858e-14a3-4c86-b36f-418fa135b0a9", hoisted8, "id", "_" + (ctrl.id) + "_1")
        elementOpen("vsd-breadcrumbs", "5ab1af8b-59fb-4488-9cb8-993461545ea8", hoisted9, "model", breadcrumbs, "onclickcrumb", function ($event) {
          var $element = this;
        ctrl.onClickTreeNode($event.item)})
          if (true) {
            skip()
          } else {
          }
        elementClose("vsd-breadcrumbs")
        if (model.errors.length) {
          elementOpen("div", "91741bbc-c203-43eb-bd03-bb4db56c3433", hoisted10)
            elementOpen("h4", "1b5b5e8c-8afb-455e-a3db-81ab7d405117", hoisted11)
              text("Errors")
            elementClose("h4")
            elementOpen("ul")
              __target = model.errors
              if (__target) {
                ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
                  var item = $value
                  var $key = "7409dece-ae08-4741-a6fc-53a26dfac4b8_" + $item
                  elementOpen("li", $key)
                    elementOpen("a", "31f1516f-79fb-4cea-8ca1-9ca6a054b394_" + $key, hoisted12, "onclick", function ($event) {
                      var $element = this;
                    ctrl.onClickErrorNode(item)})
                      text("" + (item.error) + "")
                    elementClose("a")
                  elementClose("li")
                }, this)
              }
            elementClose("ul")
          elementClose("div")
        }
        elementOpen("div", "7a763a77-9e1b-490b-8c1e-d62e9866f38e", hoisted13)
          elementOpen("div", "dff8b844-ba44-4ab6-82ba-97a82bdadc55", hoisted14)
            elementOpen("ul", "f06f91a7-0384-4c88-b426-c16d519aee10", hoisted15)
              elementOpen("li")
                elementOpen("i", "31d21038-e11a-4537-b5f4-0971f1bfe833", hoisted16)
                elementClose("i")
                elementOpen("a", null, null, "onclick", function ($event) {
                  var $element = this;
                ctrl.currentItem = model})
                  text("" + (model.name || 'Enter name') + "")
                elementClose("a")
                elementOpen("ul")
                  var schemas = model.schemas.slice().sort(function (a, b) { return a.name > b.name })
                  __target = schemas
                  if (__target) {
                    ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
                      var schema = $value
                      var $key = "46a7c251-6535-467f-87b2-8499afda8b97_" + $item
                      elementOpen("li", $key)
                        var isExpanded = ctrl.isExpanded(schema)
                        elementOpen("i", "9a3b8347-ea42-4d7c-b2d9-a622256bef0a_" + $key, hoisted17, "style", {color: schema.isVirtual ? '#aaa' : '#000'}, "onclick", function ($event) {
                          var $element = this;
                        ctrl.onClickToggleNode(schema)})
                        elementClose("i")
                        elementOpen("a", null, null, "onclick", function ($event) {
                          var $element = this;
                        ctrl.onClickTreeNode(schema)})
                          text("" + (schema.name) + "")
                        elementClose("a")
                        elementOpen("div", null, null, "style", {display: isExpanded ? 'block' : 'none'})
                          keysView(schema.keys, ctrl)
                        elementClose("div")
                      elementClose("li")
                    }, this)
                  }
                elementClose("ul")
              elementClose("li")
            elementClose("ul")
          elementClose("div")
          if (ctrl.currentItem) {
            elementOpen("div", "f15f5ae9-041c-4d6d-9b2a-8b5462d76083", hoisted18)
              if (ctrl.currentItem === model) {
                modelView(model, ctrl)
              } else if (ctrl.currentItem.isSchema) {
                schemaView(ctrl.currentItem, ctrl)
              } else if (ctrl.currentItem.isKey) {
                keyView(ctrl.currentItem, ctrl)
              }
            elementClose("div")
          }
        elementClose("div")
      elementClose("div")
      elementOpen("div", "f0570cc7-60bc-4946-8c75-bea850af66c9", hoisted19, "id", "_" + (ctrl.id) + "_2")
        elementOpen("div", null, null, "class", ctrl.isGraphExpanded ? 'expanded' : '')
          elementOpen("button", "5a29968e-ff16-40b2-989b-867f3d5d5675", hoisted20, "onclick", function ($event) {
            var $element = this;
          ctrl.isGraphExpanded = true})
            elementOpen("i", "61e32424-4d09-4b7d-837d-01d051c4ea26", hoisted21)
            elementClose("i")
          elementClose("button")
          elementOpen("button", "cedc092d-9e49-4cc4-b2ea-368b96d84d7c", hoisted22, "onclick", function ($event) {
            var $element = this;
          ctrl.isGraphExpanded = false})
            elementOpen("i", "3f4ce0ad-f0c0-4248-91fa-031d70a6e6e1", hoisted23)
            elementClose("i")
          elementClose("button")
          elementOpen("svg", "ba28a1f8-6955-49f5-9644-eb836e7dcfd0", hoisted24)
            elementOpen("g")
              if (true) {
                skip()
              } else {
              }
            elementClose("g")
          elementClose("svg")
        elementClose("div")
      elementClose("div")
      elementOpen("div", "f48700be-8033-47c7-8096-7ee573f90b9a", hoisted25, "id", "_" + (ctrl.id) + "_3")
        elementOpen("pre", "ba5195dc-54c5-4ca1-a91c-7bd5f7809150", hoisted26)
          text("" + (JSON.stringify(model, null, 2)) + "")
        elementClose("pre")
      elementClose("div")
    elementClose("div")
  elementClose("div")
}
